
export default {
    vi: {
        vietnamese: 'Tiếng Việt',
        english: 'Tiếng Anh',
    }, en: {
        vietnamese: 'Vietnamese',
        english: 'English',
    }
}